// frontend/app/plugins/session.client.ts
//
// Starts the session bootstrap WITHOUT awaiting it: public pages paint
// immediately (the persisted auth store already renders the correct header
// state), and auth.global.ts is the only awaiter of session.ready, so
// protected routes wait for the bootstrap to settle. (frontend ADR-0001)
export default defineNuxtPlugin(() => {
  void useSession().bootstrap()
})
